
<template>
  <div>
    <canvas
      ref="canvas"
      :width="canvasSize"
      :height="canvasSize"
      style="border: 1px solid #ccc"
    ></canvas>
  </div>
</template>
  
  <script>
import { Toast } from 'vant';
import { GetcouponQRCode } from '@/api/QRcode'
import QRCode from 'qrcode';
export default {
  props: {

  },
  name: 'invoiceSearch',
  data () {
    return {
      timer: null,
      invalidTime: 120,//倒计时
      canvasSize: 580, // 设置 canvas 的宽高为 240px
      uuid: '',
      parkId: '',
      qrUrl: '',
      merhantId: '',
      logoUrl: require('../../assets/zxyw_icon_web.png'),
      logoSize: 80
    }
  },
  components: {
    QRCode
  },
  destroyed () {
    Toast.clear()
  },
  computed: {

  },
  watch: {

  },
  created () {
    this.parkId = this.$route.params.id
    this.merhantId = this.$route.params.merchartID
    this.uuid = this.generateUUID();

    this.countdownTimer()
  },
  mounted () {


  },
  methods: {
    // 处理倒计时生成二维码逻辑
    countdownTimer () {
      this.getCounponQRCode()
      setTimeout(() => {
        // 处理倒计时过大执行问题
        this.scheduleEverySeconds(this.invalidTime, () => {
          this.getCounponQRCode()
        })
      }, 2000)
    },
    async getCounponQRCode () {
      clearInterval(this.timer)
      Toast.loading({
        message: '生成中...',
        forbidClick: true,
        duration: 0
      });
      const { data } = await GetcouponQRCode({
        parkId: this.parkId,
        seqNo: this.uuid,
        merhantId: this.merhantId
      })
      if (data.code == 200) {
        this.invalidTime = data.data.invalidTime * 1
        Toast.clear()
        this.qrUrl = `${data.data.qrUrl}?parkId=${data.data.parkId}&orgCode=${data.data.orgCode}&requestTime=${data.data.requestTime}&seqNo=${data.data.seqNo}&merhantId=${this.merhantId}`
        this.generateQRCode(this.qrUrl)
        // 旧的，有阈值 24天，
        // this.timer = setTimeout(() => {
        //   this.getCounponQRCode()
        // }, 1000 * this.invalidTime);


      } else {
        Toast(data.msg)
      }
    },

    generateUUID () {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0].toString(16)
      ))
    },
    generateQRCode (url) {
      console.log(url);
      QRCode.toCanvas(
        this.$refs.canvas,
        url,
        {
          errorCorrectionLevel: 'H',
          width: this.canvasSize, // 设置二维码的宽度
        },
        (error) => {
          if (error) console.error(error);
          console.log('QR code generated!');
        }
      );
      this.addLogoToQRCode()
    },
    addLogoToQRCode () {
      const canvas = this.$refs.canvas
      const ctx = canvas.getContext('2d')

      // 创建Logo图片
      const logoImg = new Image()
      logoImg.crossOrigin = 'Anonymous'
      logoImg.src = this.logoUrl

      logoImg.onload = () => {
        // 计算Logo位置（居中）
        const x = (canvas.width - this.logoSize) / 2
        const y = (canvas.height - this.logoSize) / 2

        // 绘制白色背景
        ctx.fillStyle = '#ffffff'
        ctx.fillRect(x, y, this.logoSize, this.logoSize)

        // 绘制Logo
        ctx.drawImage(logoImg, x, y, this.logoSize, this.logoSize)
      }
    },

    /**
     * scheduleEverySeconds(intervalSeconds, task)
     * - intervalSeconds: 间隔秒数（例如 2_592_000）
     * - task: 要周期执行的函数（同步或异步都可以）
     * 返回一个对象 { cancel() } 可以停止后续执行。
     */
    scheduleEverySeconds (seconds, task) {
      const intervalMs = seconds * 1000;
      const MAX = 2147483647; // 最大 setTimeout 毫秒数
      let cancelled = false;

      function waitAndRun () {
        if (cancelled) return;

        const start = Date.now();
        let remaining = intervalMs;

        // 分段等待，只等待，不执行任务
        function waitChunk () {
          if (cancelled) return;

          const chunk = Math.min(remaining, MAX);

          setTimeout(() => {
            if (cancelled) return;

            remaining -= chunk;

            if (remaining > 0) {
              waitChunk();        // 继续等待
            } else {
              runTask();          // 真正执行任务（只执行一次）
            }
          }, chunk);
        }

        waitChunk();

        function runTask () {
          if (cancelled) return;

          try {
            task();
          } catch (e) {
            console.error("任务出错：", e);
          }

          // 下一轮（重新开始完整计时）
          waitAndRun();
        }
      }

      waitAndRun();

      return {
        cancel () { cancelled = true; }
      };
    }



  },
};
  </script>

  <style scoped lang="less">
body {
  background: #f7f8fa;
}
canvas {
  width: 240px; /* 设置 CSS 显示大小 */
  height: 240px; /* 设置 CSS 显示大小 */
  margin-top: 20px;
}
</style>
  